<form [formGroup]="formGroup" (submit)="saveChanges()" fxLayout="column" fxLayoutAlign="center center">
 
  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="close(false)" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ data?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_WEB_USER' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_WEB_USER' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="loading.submit">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>
 
  <div fxLayout="column" class="padding-25" fxFlexFill>
    <!-- web-user-dropdown -->
    <esc-web-user-dropdown 
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="webUserSelected($event)"
      [previousData]="data"
      [disabled]="isDisabled"
      [groupMntDropdown]="true"
      *ngIf="data.id"
      >
    </esc-web-user-dropdown>
  
    <esc-web-user-multiselect-dropdown 
      class="width-100" 
      [labelFlex]="20"
      [formWrapperFlex]="'auto'" 
      [textLabel]="webUserSelectorLabel" 
      [wrapperLayoutAlign]="'start center'"
      [groupMntDropdown]="true"
      [previousData]="data"
      [disabled]="isDisabled"
      (webUserSelected)="webUserSelected($event)"
      *ngIf="!data.id"
      >
    </esc-web-user-multiselect-dropdown>
 
    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>
 
  </div>
</form>